import React, { useEffect, useLayoutEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './ContactPage.css';
import { Helmet } from 'react-helmet-async';

export default function ContactPage() {
  const navigate = useNavigate();

  // useLayoutEffect s'exécute avant le rendu visuel
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect comme sécurité supplémentaire
  useEffect(() => {
    // Scroll immédiat
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    
    // Scroll avec délais multiples
    const timeouts = [10, 50, 100, 200, 500].map(delay => 
      setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }, delay)
    );
    
    // Nettoyage des timeouts
    return () => timeouts.forEach(clearTimeout);
  }, []);

  return (
    <div className="contact-page-container animated-fade-in">
      <Helmet>
        <title>Contact - Gates of Music | Assistance & Partenariat Maroc</title>
        <meta name="description" content="Contactez Gates of Music pour booking musiciens, assistance technique ou partenariat au Maroc. Email, téléphone +212 6 24 38 13 11, Ben Guerir." />
        <meta name="keywords" content="contact, gates of music, booking, assistance, partenariat, musiciens maroc, ben guerir" />
        <link rel="canonical" href="https://www.gatesofmusic.com/contact" />
        
        {/* Open Graph optimisé */}
        <meta property="og:title" content="Contact Gates of Music - Assistance & Partenariat" />
        <meta property="og:description" content="Besoin d'aide pour votre booking musical au Maroc ? Contactez notre équipe Gates of Music par email ou téléphone." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.gatesofmusic.com/contact" />
        <meta property="og:image" content="https://www.gatesofmusic.com/cover.jpg" />
        <meta property="og:site_name" content="Gates of Music" />
        
        {/* Twitter Cards */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Contact Gates of Music" />
        <meta name="twitter:description" content="Contactez-nous pour booking, assistance ou partenariat musical au Maroc" />
        <meta name="twitter:image" content="https://www.gatesofmusic.com/cover.jpg" />
        
        {/* Données structurées */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Contact Gates of Music",
            "description": "Page de contact pour Gates of Music - Plateforme de booking musical au Maroc",
            "url": "https://www.gatesofmusic.com/contact",
            "mainEntity": {
              "@type": "Organization",
              "name": "Gates of Music",
              "url": "https://www.gatesofmusic.com/",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+212624381311",
                "contactType": "customer support",
                "email": "ElMehdi.RHISSANE@emines.um6p.ma",
                "availableLanguage": ["French", "Arabic"],
                "areaServed": "MA"
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Lot 660",
                "addressLocality": "Ben Guerir",
                "postalCode": "43150",
                "addressCountry": "MA"
              },
              "openingHours": [
                "Mo-Fr 09:00-18:00",
                "Sa 10:00-14:00"
              ]
            }
          })}
        </script>
        
        {/* Schema Local Business */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Gates of Music",
            "description": "Plateforme de réservation musicale au Maroc",
            "telephone": "+212624381311",
            "email": "ElMehdi.RHISSANE@emines.um6p.ma",
            "url": "https://www.gatesofmusic.com/",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Lot 660",
              "addressLocality": "Ben Guerir",
              "postalCode": "43150",
              "addressCountry": "MA"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "32.2361",
              "longitude": "-7.9511"
            },
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                "opens": "09:00",
                "closes": "18:00"
              },
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Saturday",
                "opens": "10:00",
                "closes": "14:00"
              }
            ],
            "priceRange": "$$"
          })}
        </script>
      </Helmet>

      <h1>Contactez-nous</h1>

      <p>
        Vous avez une question ou souhaitez un accompagnement personnalisé ? 
        N'hésitez pas à nous contacter via les moyens ci-dessous :
      </p>

      <div className="contact-info">
        <div className="contact-card">
          <h3>Email</h3>
          <p>ElMehdi.RHISSANE@emines.um6p.ma</p>
        </div>

        <div className="contact-card">
          <h3>Téléphone</h3>
          <p>+212 6 24 38 13 11</p>
        </div>

        <div className="contact-card">
          <h3>Adresse</h3>
          <p>Lot 660, Ben Guerir 43150</p>
        </div>

        <div className="contact-card">
          <h3>Horaires</h3>
          <p>Lundi - Vendredi : 9h - 18h</p>
          <p>Samedi : 10h - 14h</p>
          <p>Dimanche : Fermé</p>
        </div>
      </div>

      <button 
        className="btn-return-home"
        onClick={() => navigate('/')}
      >
        Retour à l'accueil
      </button>
    </div>
  );
}